// Generated by `npm run reeffish` (scripts/reefFish.ts): each stock's young's crowding fitted to its steepness, an eaten
// stock's at the predation its balance holds (`steepBalance`, M255), the rest's by `npm run reeffish -- steepness`, their larvae settling as
// Wren et al.'s model sends them (./exchange.ts, from data/bcodmo-665467/). Do not edit by hand.

import type { FishSpeciesId } from '../../fish';

/** Each stock's young's crowding fitted to its steepness (M214), m² a fish a day: its recruits at a fifth of its unfished spawners its steepness's share of its unfished recruits. */
export const STEEPNESS_CROWDING: Readonly<Partial<Record<FishSpeciesId, number>>> = {
  bullethead: 0.636789,
  palenose: 0.152391,
  roi: 71.522,
  kala: 368.135,
  ulua: 1015.29,
  omilu: 246.962,
  redlip: 6.02042,
  nenue: 641.789,
  manini: 12.0696,
  taape: 8.22279,
};
